var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "5",
      "width": "18",
      "height": "14",
      "rx": "2",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M6 14l2-2 3 3 4-4 3 3"
    }
  }), _c('path', {
    attrs: {
      "stroke-width": "2",
      "stroke-linecap": "round",
      "d": "M6 9h6"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }